import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from "@mui/material";
import imgNotFound from "assets/images/not-found.png";
import { roundToTwo } from "utils/helpers";
import { getTypedVal } from "utils/urls";
import { apiUrl } from "consts";
import { PortfolioData } from "types";
import { getFamilyImage } from "../utils/result-data";
import getStyles from "./styles";

type Props = {
  families: { data: PortfolioData | null };
  imgLvk: string | null;
  articleNumber: string;
  varNumber: string | undefined;
  lightFlux: string;
  power: number | null;
  loadPerKm: string | number;
  lampset: string;
  selectedResult: string | number;
  resultFamilyIndex: number;
};

const LuminaireFound: FC<Props> = ({ families, imgLvk, articleNumber, varNumber, lightFlux, power, loadPerKm, lampset, selectedResult, resultFamilyIndex }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).LuminaireFound, [theme]);

  const familyIds = getTypedVal("family_ids");
  const resolvedFamilies = ("families" in families ? families : families.data) ?? {};
  const imgFamily = getFamilyImage(resolvedFamilies as Parameters<typeof getFamilyImage>[0], familyIds, resultFamilyIndex);

  return (
    <Box sx={styles.container}>
      <Typography variant="h2" sx={styles.title}>
        {t("Luminaire found")}
      </Typography>

      <TableContainer component={Paper} sx={styles.card}>
        <Box component="img" src={imgLvk === "" || imgLvk === null ? imgNotFound : `${apiUrl}${imgLvk}`} sx={styles.image} />
        <Box component="img" src={imgFamily === "" ? imgNotFound : imgFamily} sx={styles.image} />

        <Table padding="none" sx={styles.table}>
          <Box component="caption" sx={styles.caption}>
            {articleNumber} {typeof varNumber !== "undefined" ? `/ ${varNumber}` : ""}
          </Box>
          <TableBody>
            <TableRow>
              <TableCell>{t("Luminous flux")}</TableCell>
              <TableCell>{lightFlux} lm</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Power Consumption")}</TableCell>
              <TableCell>{roundToTwo(power ?? 0)} W</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Load per km")}</TableCell>
              <TableCell>{roundToTwo(loadPerKm as unknown as number)} W/km</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Lampset")}</TableCell>
              <TableCell>{lampset}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LuminaireFound;
